import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import * as Fonts from "../../../styles/typography";
import * as Colors from "../../../styles/colors";
import UnityInfo from "./UnityInfo";

import { Dimensions } from "react-native";
import { useState } from "react";

const width = Dimensions.get("window").width; //width
const height = Dimensions.get("window").height; //height

export default function PaymentInfo({ contractData, moreInfo }) {
  return (
    <View style={styles.viewPaymentInfoData}>
      <View style={styles.viewValue}>
        <Text style={styles.info}>{"R$"}</Text>
        <Text style={styles.value}>{contractData.totalAmount.toString().replace(".",",")}</Text>
      </View>
      {moreInfo ? (
        <View 
        // style={{paddingHorizontal: 4}}
        >
          {contractData.amountSpace ? <UnityInfo contractData={contractData} /> : null}
        </View>
      ) : null}
      <Text style={styles.moreInfo}>
        {moreInfo ? "Menos informações" : "Mais informações"}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  viewPaymentInfoData: {
    width: width,
    alignContent: "center",
    justifyContent: "center",
  },
  viewPaymentInfoTitle: {
    flexDirection: "row",
    alignItems: "center",
  },
  label: {
    fontSize: Fonts.FONT_SIZE_22,
    fontWeight: "bold",
    color: Colors.BLACK,
  },
  labelSecondary: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK,
  },
  info: {
    fontSize: Fonts.FONT_SIZE_22,
    color: Colors.BLACK,
    textAlignVertical: "bottom",
    marginBottom: 8,
  },
  value: {
    fontSize: 48,
    fontWeight: "bold",
    color: Colors.BLACK,
    textAlignVertical: "bottom",
  },
  viewValue: {
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
  },
  moreInfo: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    textDecorationLine: "underline",
    color: Colors.HYPERLINK,
  },
});
